import React, {Component, useRef, useState} from "react";
import PropTypes from "prop-types";
import {Form, Notification} from "react-bulma-components";
import {Heading} from "react-bulma-components";
import {Columns} from "react-bulma-components";
import {Container} from "react-bulma-components";
import {Box} from "react-bulma-components";
import {Button} from "react-bulma-components";

import axios from "axios";
import {fixEmptyDepartment, getDaysBetween, getQueryString} from "../../utils";
import VehicleFinderSection from "./VehicleFinderSection";
import ContactSection from "../Contact/ContactSection";
import InsuranceSection from "./InsuranceSection";
import LicenceSection from "./LicenceSection";
import RatesSection from "./RatesSection";
import OffHireSection from "./OffHireSection";
import {NotificationManager} from "react-notifications";
import {
    getDataFresh,
    getDepartmentsData, getDriversData, getKeysData, getMovementRatesData, getMovementTypesData, getNominalCodesData,
    getRateCardsData,
    getRentalData,
    getRentalMarginData,
    getTrackingOptionsData
} from "../../state/selectors";
import {useDispatch, useSelector} from "react-redux";
import useSafeSave from "../../hooks/useSafeSave";
import {createSetDataFreshAction, createSetRentalAction, createSetRentalFieldAction} from "../../actions/dataActions";
import ReactToPrint from "react-to-print";
import PrintRental from "./PrintRental";
import useButtonSelect from "../../hooks/useButtonSelect";
import {DepositSection} from "./DepositSection";
import {OnHireSection} from "./OnHireSection";
import {getSuggestedRate, getShortTermRate} from "../Utils/RentalRateCalculator";
import DepartmentPicker from "../Job/DepartmentPicker";
import DepartmentSelector from "../Settings/Departments/DepartmentSelector";
import TrackingOptionsPicker from "../Settings/TrackingCategory/TrackingOptionsPicker";
import CreateMovement from "../Movement/CreateMovement";
import MovementSection from "./MovementSection";
import {useUtilData} from "../../hooks/useUtilData";
import {useRateCardsData} from "../../hooks/useRateCardsData";
import MovementCheckModal from "./MovementCheckModal";
import NominalCodePicker from "../Settings/NominalCodes/NominalCodePicker";
import InvoiceSection from "./InvoiceSection";
import PrintMissingFuel from "./PrintMissingFuel";
import PrintContractDetails from "./Contracts/PrintContractDetails";
import PrintContract from "./Contracts/PrintContract";
import PrintLog from "./PrintLog";
import PrintDVHTermsConditions from "./Contracts/PrintDVHTermsConditions";
import InspectionFormSection from "./InspectionFormSection";
import CashSaleSection from "../Contact/CashSaleSection";
import QuoteSection from "./Quotes/QuoteSections";
import CreateQuoteModal from "./Quotes/CreateQuoteModal";
import CreateDuplicateQuoteModal from "./Quotes/CreateDuplicateQuoteModal";

function RentalsForm(props) {
  const dispatch = useDispatch();
  const [lastChange, setLastChange] = useState();
  const [movementModalOpen, setMovementModalOpen] = useState(false);
  const [movementConfirmModalOpen, setMovementConfirmModalOpen] = useState(false);
  const [createQuoteModalOpen, setCreateQuoteModalOpen] = useState(false);
  const [rateParams, setRateParams] = useState({page_size: 1000});
  const [createDuplicateQuoteModalOpen, setCreateDuplicateQuoteModalOpen] = useState(false);
  const printRentalRef = useRef();
  const printMissingRef = useRef();
  const printTermsRef = useRef();
  const initVehicle = new URLSearchParams(props.location.search).get("initVehicle");
  let dataFresh = useSelector(getDataFresh);

  const rateCardsLoaded = useRateCardsData(rateParams, dataFresh);

  const dateFields = [
    "tax_expiry",
    "date_sold",
    "finish_date",
    "depreciation_start_date",
    "off_hire_date",
    "insurance_expiry",
    "deposit_paid_date",
    "initial_payment_date",
    "chargeable_date",
    "deposit_paid_date",
    "initial_payment_date",
    "deposit_refunded_date",
    "licence_check_date",
    "on_hire_date",
    "licence_expiry_date",
    "start_time",
    "finish_time",
    "on_hire_time",
    "off_hire_time",
    "date_of_quote_received",
    "date_of_damage_indicated"
  ];

  const typeFields = ["L1", "L2", "L3", "L4", "Car"];

  const rates = [
    "first_day",
    "two_five_days",
    "six_twenty_seven_days",
    "twenty_eight_plus",
    "one_week",
    "six_twenty_seven_week",
    "long_term_daily",
    "weekend"
  ];

  const day = 1000 * 60 * 60 * 24;

  let rental = useSelector(getRentalData);
  let margins = useSelector(getRentalMarginData);
  let departments = useSelector(getDepartmentsData);
  let rateCards = useSelector(getRateCardsData);
  let trackingOptions = useSelector(getTrackingOptionsData);
  let nominalCodes = useSelector(getNominalCodesData);
  let keys = useSelector(getKeysData);
  let movementRates = useSelector(getMovementRatesData);
  let movementTypes = useSelector(getMovementTypesData);
  let drivers = useSelector(getDriversData);

  const autoFill = {customers: []}

  if(rental.id){
      autoFill.rental = rental;
  }
  if(rental.vehicle){
      autoFill.vehicle = rental.vehicle.registration;
  }
  if(rental.department){
      autoFill.department = rental.department
  }
  if(rental.payer){
      autoFill.customers = [rental.payer]
  }
  if(rental.customer && rental.customer.id){
      autoFill.customers.push(rental.customer);
  }

  const [suggestedRate, setSuggestedRate] = useState(getSuggestedRate(rental.vehicle, rental.mileage_allowance, rental.chargeable_date, rental.term, rental.margin, rental.additional_cost))

  if (initVehicle && (!rental.vehicle || !rental.vehicle.id)) {
    axios.get(props.endpoint + `vehicles/${initVehicle}`).then(resp => {
      dispatch(createSetRentalFieldAction({vehicle: resp.data}))
    })
  }

  let hire_days = getDaysBetween(new Date(rental.chargeable_date), new Date(rental.finish_date));
  let hire_cost = getShortTermRate(rental, hire_days);
  let insurance_cost = rental.insurance_daily * hire_days;

  const onDuplicate = () => {
      setCreateDuplicateQuoteModalOpen(true)
  }

  const onQuoteDuplicate = quote => {
      const conf = {
        method: "post",
        data: quote,
        url: props.endpoint+"duplicatequote"
      };
      axios(conf).then(res => {
        window.open("/editquote/"+res.data.id, "_self");
      })
  }

  const validator = () => {
      let cash_sales = rental.cash_sale;
      let valid = true;
      cash_sales.forEach(sale => {
         if(!(!!sale.name)){
             NotificationManager.warning("Cash Sale Name required");
             valid = false;
         }
         if(!(!!sale.address)){
             NotificationManager.warning("Cash Sale Address required");
             valid = false;
         }
      });
      if(!(!!rental.invoice_interval) || rental.invoice_interval === "" || (rental.invoice_interval === "NONE" && rental.rental_type === "LT")){
          NotificationManager.warning("Invoice Interval is required");
          valid = false;
      }
      return {
          missingPartSuppliers: [],
          missing: [],
          invalidWorkTypes: [],
          missingTrackingOptions: [],
          result: valid
      }
  }

  const save = e => {
    let rentalToSave = rental;
    rentalToSave = fixEmptyDates(rentalToSave);
    rentalToSave = fixEmptyDepartment(rentalToSave);
    if (!rentalToSave.margin) {
      rentalToSave.margin = margins.results[0]
    }
    const endpoint = rentalToSave.id
      ? props.endpoint + "rentals/" + rentalToSave.id
      : props.endpoint + "createrental";
    const method = rentalToSave.id ? "put" : "post";

    const conf = {
      method: method,
      data: rentalToSave,
      url: endpoint
    };
    return axios(conf).then(resp => {
      dispatch(createSetRentalAction(resp.data));
      if (!rental.id) {
        props.history.push("/editrental/" + resp.data.id);
        setMovementConfirmModalOpen(true);
      }
    }).catch(err => NotificationManager.error("An error occured!"));

  }

  const validate = () => {
    let fields = ['policy_name', 'insurer', 'policy_number', 'insurance_expiry',
                            'ni_number', 'licence_number', 'licence_type']
    if(rental.corp_licence){
        fields = ['policy_name', 'insurer', 'policy_number', 'insurance_expiry']
    }
    let result = true;
    fields.forEach(field => {
      if (!rental[field]) {
        result = false;
      }
    })
    return result;
  }
  const checkNotUpdated = () => {
    if (rental.id) {
      return axios
        .get(props.endpoint + "rentals/" + rental.id)
        .then(
          result => {
            return (new Date(result.data.last_saved).getTime() -
                new Date(rental.last_saved).getTime()) /
              1000 <
              1
          }
        ).catch(err => {
          NotificationManager.error("An error occurred!");
        });
    }
    return new Promise((res, rej) => res(true));
  };

  const [makeDirty, safeSave] = useSafeSave(
    save,
    lastChange,
      () => validator(),
    checkNotUpdated
  );


  const triggerChange = (data, callBack) => {
    makeDirty();
    setLastChange(new Date());
    dispatch(createSetRentalFieldAction(data))
    if(callBack){
      callBack();
    }
    setSuggestedRate(getSuggestedRate(rental.vehicle, rental.mileage_allowance, rental.chargeable_date, rental.term, rental.margin, rental.additional_cost));
  };


  const onRatesChange = e => {
    if (e.target.name === "excess_mileage_charge_per_mile"){
        return onOffHireChange(e);
    }
    let newRental = rental;
    if (rental.rental_type === "ST"){
        newRental[e.target.name] = e.target.value;
        newRental = calculateSTH(newRental);
        console.log(newRental.short_term_total);
        triggerChange({...newRental});
    }
    else if (rental.rental_type === "LT"){
        newRental[e.target.name] = e.target.value;
        newRental = calculateLTH(newRental);
        triggerChange({...newRental});
    }
    else{
        triggerChange({[e.target.name]: e.target.value})
    }

    // triggerChange({[e.target.name]: e.target.value}, () => {
    //   if (rental.rental_type === "LT") return calculateLTH();
    //   if (rental.rental_type === "ST") return calculateSTH();
    // });
  };

  const getMileageExcess = (rental) => {
    if((rental.chargeable_date || rental.on_hire_date) &&
        rental.off_hire_mileage && rental.start_mileage && rental.off_hire_date){
        let startDate;
        if(rental.on_hire_date){
            startDate = new Date(rental.on_hire_date)
        }
        else if(rental.chargeable_date){
            startDate = new Date(rental.chargeable_date)
        }

        let milesUsed = rental.off_hire_mileage - rental.start_mileage;

        // ST and FOC now have their own mileage allowance (its stored as a daily value)
        // the daily allowance for short term is 100 miles a day
        let dailyMileageAllowance = 100
        if(rental.rental_type === "LT") {
            dailyMileageAllowance = rental.mileage_allowance / 365;
        }
        else if (rental.rental_type === "ST" || rental.rental_type === "FOC"){
            dailyMileageAllowance = rental.mileage_allowance;
        }

        let dateDiff = new Date(rental.off_hire_date) - startDate;
        let days = (dateDiff / (1000 * 60 * 60 * 24)) + 1; // days needs to include the day they take the vehicle

        let actualAllowance = dailyMileageAllowance * days;

        if(milesUsed > actualAllowance){
            return Math.round((milesUsed - actualAllowance) * 100) / 100
        }
        else{
            return 0
        }
    }
    else{
        return 0
    }
  }

  const calcOffHireCosts = (rental) => {
      // takes a rental object
      // returns a rental object with off hire costs set
      if(!rental.off_hire_excess_mileage_override) {
          rental.off_hire_excess_mileage = getMileageExcess(rental);
      }

      let excess_mileage_charge = 0;
      if(rental.off_hire_excess_mileage) {
        excess_mileage_charge = Math.round(((parseFloat(rental.off_hire_excess_mileage) * rental.excess_mileage_charge_per_mile) * 100)) / 100;
      }
      const off_hire_total_additional_charges =
        parseFloat(rental.off_hire_new_damage) +
        parseFloat(rental.off_hire_missing_fuel) +
        parseFloat(rental.off_hire_ad_blue_charge) +
        excess_mileage_charge;

      if(!rental.excess_mileage_charge_override) {
          rental.excess_mileage_charge = excess_mileage_charge || 0;
      }
      if(!rental.off_hire_total_additional_charges_override) {
          rental.off_hire_total_additional_charges = off_hire_total_additional_charges || 0;
      }

      return rental
  }


  const onOffHireChange = e => {
    // triggerChange({[e.target.name]: e.target.value}, () => {
    //   let excess_mileage_charge = 0;
    //   if(rental.off_hire_excess_mileage) {
    //     excess_mileage_charge = parseFloat(rental.off_hire_excess_mileage) * rental.excess_mileage_charge_per_mile;
    //   }
    //
    //   const off_hire_total_additional_charges =
    //     parseFloat(rental.off_hire_new_damage) +
    //     parseFloat(rental.off_hire_missing_fuel) +
    //     excess_mileage_charge;
    //
    //   triggerChange({
    //     excess_mileage_charge: excess_mileage_charge.toFixed(2),
    //     off_hire_total_additional_charges: off_hire_total_additional_charges.toFixed(
    //       2
    //     )
    //   });
    // });

    let newRental = {...rental, [e.target.name]: e.target.value};
    if(e.target.name === "off_hire_date"){
        // when you off hire a contract, update the expected off hire date aswell
        newRental['finish_date'] = e.target.value
    }
    newRental = calcOffHireCosts(newRental);
    triggerChange({...newRental})

  };

  const calculateLTH = (rental) => {
      let insuranceTotal = (rental.daily_insurance_charge * 7) * rental.term
      let total = ((rental.long_term_daily * 7) * rental.term) + parseFloat(rental.additional_cost || 0) + insuranceTotal;
      rental.total = Math.round(total * 100) / 100;

      return rental
    // return triggerChange({
    //   total:
    //     Math.round(rental.days / 7) * rental.long_term_weekly +
    //     parseFloat(rental.additional_cost || 0)
    // });
  };

  const calculateSTH = (rental) => {
    if(!(!!rental.rate_card)){
        // If there is no rate card then the cost should not be calculated
        // If the cost is being overriden then it doesnt not need to be calculated
        return rental;
    }
    const days = rental.days;
    let total = 0;
    let insuranceTotal = 0;
    let adminTotal = 0;

    // Changed day_1_2_rate to default to 1 day as the maths fails if they take it for a single day
    // New problem, off hire same day and off hire day after on hire are resulting in same day amount
    const rates = {
      day1_2_rate: days > 0 ? Math.min(2, days) : 0,
      day3_6_rate: days - 2 > 0 ? Math.min(4, days - 2) : 0,
      day7_27_rate: days - 7 > 0 ? Math.min(21, days - 7) : 0,
      day_28_plus_rate: days - 27 > 0 ? days - 27 : 0
    };

    const applyRates = {
        day1_2_rate: rental.apply_day1_2_rate,
        day3_6_rate: rental.apply_day3_6_rate,
        day7_27_rate: rental.apply_day7_27_rate,
        day_28_plus_rate: rental.apply_day_28_plus_rate
    }

    const discount = {
        day1_2_rate: 1 - (parseFloat(rental.day1_2_discount) / 100),
        day3_6_rate: 1 - (parseFloat(rental.day_3_6_discount) / 100),
        day7_27_rate: 1 - (parseFloat(rental.day_7_27_discount) / 100),
        day_28_plus_rate: 1 - (parseFloat(rental.day_28_plus_discount) / 100)
    };

    let totalUnappliedDays = 0 //store any unapplied days to then apply at the next rate
    for (var rate in rates) {
        // conditionally apply the rates
        // if a rate is not applied then the next rate should apply for all days before it
      if(applyRates[rate]){
          total += (rates[rate] + totalUnappliedDays) * (parseFloat(rental.rate_card[rate] || 0) * discount[rate]);
          if(rental.apply_insurance) {
            insuranceTotal += ((rates[rate] + totalUnappliedDays) * (parseFloat(rental.rate_card[rate] || 0) * discount[rate])) * parseFloat(rental.rate_card.insurance_perc);
          }
          if(rental.apply_admin_fee){
              adminTotal += ((rates[rate] + totalUnappliedDays) * (parseFloat(rental.rate_card[rate] || 0) * discount[rate])) * parseFloat(rental.rate_card.admin_perc);
          }
          totalUnappliedDays = 0;
      }
      else{
          // Save days to be applied at next rate
          totalUnappliedDays += rates[rate]
      }
    }

    total = total + parseFloat(rental.additional_cost || 0);
    rental.short_term_total = total;
    rental.short_term_insurance_total = Math.round(insuranceTotal * 100) / 100;
    rental.short_term_admin_total = Math.round(adminTotal * 100) / 100;
    return rental;
  };

  const handleDelete = e => {
    e.preventDefault();
    const endpoint = props.endpoint + "rentals/" + rental.id;
    const conf = {method: "delete", url: endpoint};
    axios(conf).then(response => props.history.push("/rentals"));
  };

  const handleChange = e => {
    triggerChange({[e.target.name]: e.target.value});
  };

  const onCheck = e => {
      const toUpdate = {
          target: {
              name: e.target.name,
              value: !rental[e.target.name]
          }
      };
      handleChange(toUpdate);
  }

  const handleDateChange = e => {
      let newRental = {...rental};
      newRental[e.target.name] = e.target.value;
      const start = new Date(newRental.chargeable_date);
      const end = new Date(newRental.finish_date);
      const days = Math.round(Math.abs((start.getTime() - end.getTime()) / day)) + 1;

      newRental['days'] = days
      if(newRental.rental_type === "ST"){
        newRental = calculateSTH(newRental);
      }
      else if(newRental.rental_type === "LT"){
          newRental = calculateLTH(newRental);
      }
      triggerChange({...newRental});
    // triggerChange({[e.target.name]: e.target.value}, () => {
    //   const start = new Date(rental.chargeable_date);
    //   const end = new Date(rental.finish_date);
    //   const days =
    //     Math.round(Math.abs((start.getTime() - end.getTime()) / day)) + 1;
    //   triggerChange({days: days}, () => {
    //     if (rental.rental_type === "LT") return calculateLTH();
    //     if (rental.rental_type === "ST") return calculateSTH();
    //   });
    // });
  };

  const selectVehicle = vehicle => {
    let queryString = getQueryString({
      vehicle: vehicle.id,
      on_hire_date: rental.on_hire_date,
      finish_date: rental.finish_date,
      department: rental.department ? rental.department.id : 0
    });
    axios.get(`/api/rentals${queryString}`).then(resp => {
      if (resp.data.results.length === 0 || rental.is_tracker_hire) {
        let newState = {vehicle: vehicle, start_mileage: vehicle.mileage};
        for (let rate of rates) {
          newState[rate] = vehicle[rate];
        }
        triggerChange(newState);
      } else {
        NotificationManager.warning(
          `This vehicle is already booked out to ${resp.data.results[0].customer.display_name}!`,
          "Warning!",
          10000
        );
      }
    });
  };

  const handleAfterPrint = () => {
      const conf = {
          data: rental,
          method: "post",
          url: props.endpoint+"rentalprint"
      }
      axios(conf).then(res => {
          let currentPrintLog = [...rental.rental_print_log];
          currentPrintLog.push(res.data)
          dispatch(createSetRentalFieldAction({rental_print_log: currentPrintLog}))
      })
  }

  const handleUpdateCustomer = e => {
    triggerChange({customer: e});
    setRateParams({...rateParams, customer: e.id});
  };

  const handleUpdatePayer = e => {
    triggerChange({payer: e});
  };

  const handleCheckbox = e => {
    triggerChange({[e.target.name]: e.target.checked});
  };

  const [status, buttonSelect, setStatus] = useButtonSelect({
    callback: handleChange,
    prop: 'status',
    label: "Status",
    initialValue: rental.status | 'QUOTE',
    options: [{name: "Quote", value: "QUOTE"}, {name: "Confirmed", value: "CONFIRMED"}, {
      name: "Not Requried",
      value: "NOT REQUIRED"
    }]
  })
  const fixEmptyDates = vehicle => {
    dateFields.forEach(function (date) {
      if (vehicle[date] === "") {
        vehicle[date] = null;
      }
    });
    return vehicle;
  };

  const onInspectionChange = (e, index) => {
      let newInspection = {...rental.vehicle.inspections[index], [e.target.name]: e.target.value};
      let vehicle = {...rental.vehicle};
      vehicle.inspections[index] = newInspection;
      triggerChange({vehicle: vehicle});
  }

  const departmentObjects = props.loaded ? departments.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

  const trackingOptionObjects = props.loaded ? trackingOptions.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

   const codeObjects = props.loaded ? nominalCodes.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

  const rateCardObjects = rateCardsLoaded ? rateCards.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

  const movementRateObjects = props.loaded ? movementRates.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

  const movementTypeObjects = props.loaded ? movementTypes.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

  const driverObjects = props.loaded ? drivers.results.reduce((obj, item) => {
        return {
          ...obj,
          [item["id"]]: item
        };
    }, {}) : {};

  const onDepartmentsChange = e => {
    const toUpdate = {
      target: {
        name:"department",
        value: departmentObjects[e.target.value]
      }
    }
    handleChange(toUpdate)
  };

  const onRateCardChange = e => {
      // const toUpdate = {
      //     target: {
      //         name: "rate_card",
      //         value: rateCardObjects[e.target.value]
      //     }
      // };
      let newRental = {...rental}
      newRental['rate_card'] = rateCardObjects[e.target.value]
      if(newRental.rental_type === "ST"){
          newRental = calculateSTH(newRental)
      }
      triggerChange({...newRental});
      //handleChange(toUpdate);
  };

  const onTrackingOptionChange = e => {
    const toUpdate = {
      target: {
        name:"tracking_option",
        value: trackingOptionObjects[e.target.value]
      }
    }
    handleChange(toUpdate)
  }

  const onNominalCodeChange = e => {
      const toUpdate = {
          target: {
              name: e.target.name,
              value: codeObjects[e.target.value]
          }
      }
      handleChange(toUpdate);
  }

  const handleUtilParamUpdate = (params) => {
      params.filterObj = "movement_rate"
      params.filter = params.contact
      props.setUtilsParam(params)
  };

  const addCashSale = (customerId) => {
        let newCashSale = {
            name: "",
            email: "",
            phone: "",
            address :"",
            contact: customerId
        };
        rental.cash_sale.push(newCashSale);
        triggerChange({cash_sale: rental.cash_sale})
  };

  const onCashSaleChange = (e, index) => {
        let cashSale = {...rental.cash_sale[index]}
        cashSale[e.target.name] = e.target.value;
        rental.cash_sale[index] = cashSale;
        triggerChange({cash_sale: rental.cash_sale});
  };

  const customerCashSaleChange = (e, index) => {
    let cashSales = rental.cash_sale.filter((sale) => sale.contact === rental.customer.id);
    let targetCashSale = cashSales[index];
    let trueIndex = rental.cash_sale.indexOf(targetCashSale);
    onCashSaleChange(e, trueIndex);
  }

  const payerCashSaleChange = (e, index) => {
    let cashSales = rental.cash_sale.filter((sale) => sale.contact === rental.payer.id);
    let targetCashSale = cashSales[index];
    let trueIndex = rental.cash_sale.indexOf(targetCashSale);
    onCashSaleChange(e, trueIndex);
  }


  if (props.loaded && rateCardsLoaded) {
    return (
      <Container>
        <Box>
          <Heading>New Booking</Heading>
          <Columns>
            <Columns.Column>
              <Form.Control>
                <Form.Field>
                  <Form.Label>On Hire Date (*)</Form.Label>
                  <Form.Input
                    type="date"
                    name="on_hire_date"
                    onChange={handleChange}
                    value={rental.on_hire_date}
                    required
                  />
                </Form.Field>
              </Form.Control>
            </Columns.Column>
            <Columns.Column>
              <Form.Control>
                <Form.Field>
                  <Form.Label>Chargeable Date</Form.Label>
                  <Form.Input
                    type="date"
                    name="chargeable_date"
                    onChange={handleDateChange}
                    value={rental.chargeable_date}
                    required
                  />
                </Form.Field>
              </Form.Control>
            </Columns.Column>
            <Columns.Column>
              <Form.Control>
                <Form.Field>
                  <Form.Label>Expected Off Hire Date</Form.Label>
                  <Form.Input
                    type="date"
                    name="finish_date"
                    onChange={handleDateChange}
                    value={rental.finish_date}
                    required
                  />
                </Form.Field>
              </Form.Control>
            </Columns.Column>
            <Columns.Column>
              <Form.Field className="has-addons">
                <Form.Control>
                  <Form.Label>Status (*)</Form.Label>
                  <Button
                    color={rental.status === "QUOTE" ? "primary" : ""}
                    onClick={() => handleChange({target: {name: "status", value: "QUOTE"}})}
                  >
                    Quote
                  </Button>
                  <Button
                    color={rental.status === "CONFIRMED" ? "primary" : ""}
                    onClick={() => handleChange({target: {name: "status", value: "CONFIRMED"}})}
                  >
                    Confirmed
                  </Button>
                  <Button
                    color={rental.status === "NOT REQUIRED" ? "primary" : ""}
                    onClick={() => handleChange({target: {name: "status", value: "NOT REQUIRED"}})}
                  >
                    Not Required
                  </Button>
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <DepartmentSelector
                  disabled={false}
                  inlineEdit={false}
                  blank={true}
                  onChange={onDepartmentsChange}
                  options={departments}
                  value={rental.department}
                  label={"Department (*)"}
                  editable={true}
              />
            </Columns.Column>
            <Columns.Column>
              <TrackingOptionsPicker
                disabled={false}
                name={"tracking_option"}
                blank={true}
                onChange={onTrackingOptionChange}
                options={trackingOptions}
                editable={true}
                inlineEdit={false}
                label={"Tracking Option (*)"}
                value={rental.tracking_option}
              />
            </Columns.Column>
          </Columns>
          <Columns>
              <Columns.Column>
                  <NominalCodePicker
                    disabled={false}
                    name={"vat_nominal_code"}
                    blank={true}
                    onChange={onNominalCodeChange}
                    options={nominalCodes}
                    editable={true}
                    inlineEdit={false}
                    value={rental.vat_nominal_code}
                    label={"VAT Nominal Code"}
                    small={false}
                  />
              </Columns.Column>
              <Columns.Column>
                  <NominalCodePicker
                    disabled={false}
                    name={"no_vat_nominal_code"}
                    blank={true}
                    onChange={onNominalCodeChange}
                    options={nominalCodes}
                    editable={true}
                    inlineEdit={false}
                    value={rental.no_vat_nominal_code}
                    label={"No VAT Nominal Code"}
                    small={false}
                  />
              </Columns.Column>
              <Columns.Column>
                  <NominalCodePicker
                    disabled={false}
                    name={"admin_fee_nominal_code"}
                    blank={true}
                    onChange={onNominalCodeChange}
                    options={nominalCodes}
                    editable={true}
                    inlineEdit={false}
                    value={rental.admin_fee_nominal_code}
                    label={"Admin Fee Nominal Code"}
                    small={false}
                  />
              </Columns.Column>
              <Columns.Column></Columns.Column>
              <Columns.Column></Columns.Column>
              <Columns.Column></Columns.Column>
          </Columns>
        </Box>
        {(!!rental.tracking_option && !!rental.department) &&
          <VehicleFinderSection
            selectVehicle={selectVehicle}
            endpoint={props.endpoint}
            onHireDate={rental.on_hire_date}
            finishDate={rental.finish_date}
          />
        }
        <Box>
          <Heading>Vehicle</Heading>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <label className="label">Registration</label>
                <Form.Control className="registration-wrapper">
                  <Form.Input
                    className="registration-field"
                    type="text"
                    name="registration"
                    onChange={handleChange}
                    value={rental.vehicle.registration}
                    required
                    readOnly
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Tracker Hire</Form.Label>
                <Form.Control>
                  <Form.Checkbox
                    name="is_tracker_hire"
                    onChange={onCheck}
                    checked={rental.is_tracker_hire}
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Rental Start Mileage</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="number"
                    name="start_mileage"
                    onChange={handleChange}
                    value={rental.start_mileage}
                    disabled={!rental.start_mileage_override}
                    required
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Rental Start Mileage Override</Form.Label>
                <Form.Control>
                  <Form.Checkbox
                    name="start_mileage_override"
                    onChange={onCheck}
                    checked={rental.start_mileage_override}
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Make</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="text"
                    name="make"
                    onChange={handleChange}
                    value={rental.vehicle.make && rental.vehicle.make.name}
                    required
                    readOnly
                    disabled
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Model</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="text"
                    name="model"
                    onChange={handleChange}
                    value={rental.vehicle.model && rental.vehicle.model.name}
                    required
                    readOnly
                    disabled
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Mileage Limit</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="text"
                    name="model"
                    onChange={handleChange}
                    value={rental.vehicle.model && rental.vehicle.model.mileage_limit}
                    required
                    readOnly
                    disabled
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
          </Columns>
          {rental.mileage_warning &&
            <Columns>
                <Columns.Column>
                    <Notification
                        color={"warning"}
                        onClick={e => handleChange({target: {name: "mileage_warning", value: false}})}
                    >
                        This vehicle is currently over mileage (based on recent job card mileage)
                    </Notification>
                </Columns.Column>
            </Columns>
          }
        </Box>
          <Columns>
              <Columns.Column>
                  <Columns>
                      <Columns.Column>
                          <ContactSection
                              title="Hirer"
                              contactUpdate={handleUpdateCustomer}
                              endpoint={props.endpoint + "contacts"}
                              contact={rental.customer || {}}
                              displayRentalInstructions={true}
                              type="CC"
                              fullSearch
                          />
                      </Columns.Column>
                  </Columns>
                  {(rental.customer && rental.customer.is_cash_sale) &&
                        <Box>
                            <Columns>
                                <Columns.Column>
                                    <Heading>Cash Sale</Heading>
                                </Columns.Column>
                                {rental.cash_sale.filter(sale => sale.contact === rental.customer.id).length == 0 &&
                                <Columns.Column>
                                    <Button
                                        color={"success"}
                                        onClick={() => addCashSale(rental.customer.id)}
                                    >
                                        Add Cash Sale +
                                    </Button>
                                </Columns.Column>
                                }
                            </Columns>
                        </Box>
                    }
                    {(rental.customer && rental.customer.is_cash_sale) &&
                        rental.cash_sale.filter(sale => sale.contact === rental.customer.id).map((sale, index) => (
                            <Columns>
                                <Columns.Column>
                                    <CashSaleSection
                                        data={sale}
                                        index={index}
                                        onChange={customerCashSaleChange}
                                    />
                                </Columns.Column>
                            </Columns>
                        ))
                    }
              </Columns.Column>
          </Columns>
          <Columns>
              <Columns.Column>
                  <Columns>
                      <Columns.Column>
                          <ContactSection
                              title="Payer (If different from Hirer)"
                              contactUpdate={handleUpdatePayer}
                              endpoint={props.endpoint + "contacts"}
                              contact={rental.payer || {}}
                              displayRentalInstructions={true}
                              type="CC"
                              fullSearch
                          />
                      </Columns.Column>
                  </Columns>
                  {(rental.payer && rental.payer.is_cash_sale) &&
                        <Box>
                            <Columns>
                                <Columns.Column>
                                    <Heading>Cash Sale</Heading>
                                </Columns.Column>
                                {rental.cash_sale.filter(sale => sale.contact === rental.payer.id).length === 0 &&
                                <Columns.Column>
                                    <Button
                                        color={"success"}
                                        onClick={() => addCashSale(rental.payer.id)}
                                    >
                                        Add Cash Sale +
                                    </Button>
                                </Columns.Column>
                                }
                            </Columns>
                        </Box>
                    }
                    {(rental.payer && rental.payer.is_cash_sale) &&
                        rental.cash_sale.filter(sale => sale.contact === rental.payer.id).map((sale, index) => (
                            <Columns>
                                <Columns.Column>
                                    <CashSaleSection
                                        data={sale}
                                        index={index}
                                        onChange={payerCashSaleChange}
                                    />
                                </Columns.Column>
                            </Columns>
                        ))
                    }
              </Columns.Column>
          </Columns>
        <RatesSection
            onChange={onRatesChange}
            rental={rental}
            margins={margins}
            suggestedRate={suggestedRate}
            onRateCardChange={onRateCardChange}
            rateCards={rateCards}
        />
          {(rental.vehicle && rental.rental_type === "LT" && rental.mileage_allowance > 0) &&
            <InspectionFormSection
                vehicle={rental.vehicle}
                rental={rental}
                onChange={onInspectionChange}
            />
          }
        <LicenceSection onChange={handleChange} onCheck={onCheck} rental={rental} triggerChange={triggerChange}/>
        <InsuranceSection onChange={handleChange} onCheck={onCheck} handleDateChange={handleDateChange} rental={rental} triggerChange={triggerChange}/>
        <DepositSection onChange={handleChange} rental={rental}/>
        <OnHireSection onChange={handleChange} rental={rental}/>
        <OffHireSection onChange={onOffHireChange} rental={rental} onCheck={onCheck} triggerChange={triggerChange} setQuoteModalOpen={setCreateQuoteModalOpen} endpoint={props.endpoint} onDuplicate={onDuplicate}/>
        <InvoiceSection invoices={rental.invoices}/>
        <PrintLog rental={rental}/>
        {rental.vehicle &&
          <QuoteSection
            quotes={rental.quotes}
          />
        }
        <MovementSection
            movements={rental.rental_movements}
            rateData={movementRates}
            dataFresh={dataFresh}
            endpoint={props.endpoint}
            typeData={movementTypes}
            movementTypeObjects={movementTypeObjects}
            driverData={drivers}
            driverObjects={driverObjects}
            departments={departments}
            departmentObjects={departmentObjects}
            serializerField={true}
            rental={rental}
        />
        <Box>
          <Form.Field>
            <Form.Control>
              <Button
                onClick={safeSave}
                type="submit"
                fullwidth
                color="success"
              >
                Save Rental
              </Button>
            </Form.Control>
          </Form.Field>
          {rental.id && (
            <Form.Field>
              <Form.Control>
                <Button
                  onClick={() => setMovementModalOpen(true)}
                  type="submit"
                  fullwidth
                  color="info"
                >
                  Create Movement
                </Button>
              </Form.Control>
            </Form.Field>
          )}
          {rental.id && (
            <Form.Field>
              <Form.Control>
                <Button
                  onClick={handleDelete}
                  type="submit"
                  fullwidth
                  color="danger"
                >
                  Delete Rental
                </Button>
              </Form.Control>
            </Form.Field>
          )}
          {rental.id && validate() && (
            <Form.Field>
              <ReactToPrint
                trigger={() => (
                  <Button color="warning" fullwidth>
                    Print Hire Contact
                  </Button>
                )}
                content={() => printRentalRef.current}
                onAfterPrint={() => handleAfterPrint()}
                bodyClass="print-portrait"
                pageStyle="@page {
                  size: A4 portrait;
                }"
              />
            </Form.Field>
          )}
          {rental.id && !validate() && (
            <Button disabled={true} color="warning" fullwidth>Unable To Print: Missing license or insurance information</Button>
          )}
          {rental.id && (
            <Form.Field>
              <ReactToPrint
                trigger={() => (
                  <Button color="warning" fullwidth>
                    Print Missing Fuel/Adblue Sheet
                  </Button>
                )}
                content={() => printMissingRef.current}
                bodyClass="print-landscape"
                pageStyle="@page {
                  size: A4 landscape;
                }"
              />
            </Form.Field>
          )}
          {rental.id && (
            <Form.Field>
              <ReactToPrint
                trigger={() => (
                  <Button color="warning" fullwidth>
                    Print Term & Conditions
                  </Button>
                )}
                content={() => printTermsRef.current}
                bodyClass="print-portrait"
                pageStyle="@page {
                  size: A4 portrait;
                }"
              />
            </Form.Field>
          )}
        </Box>
          {rental.id &&
        <CreateMovement
            autoFill={autoFill}
            endpoint={props.endpoint}
            open={movementModalOpen}
            setOpen={setMovementModalOpen}
            movementRateOptions={movementRates}
            movementTypeOptions={movementTypes}
            movementRateObjects={movementRateObjects}
            movementTypeObjects={movementTypeObjects}
            departments={departments}
            departmentObjects={departmentObjects}
            driverOptions={drivers}
            driverObjects={driverObjects}
            dataFresh={dataFresh}
            movementRateParams={props.utilsParam}
            setMovementRateParams={handleUtilParamUpdate}
        />
          }
        <MovementCheckModal
            show={movementConfirmModalOpen}
            setShow={setMovementConfirmModalOpen}
        />
        <CreateQuoteModal
            show={createQuoteModalOpen}
            setShow={setCreateQuoteModalOpen}
            rental={rental}
            endpoint={props.endpoint}
            departments={departments}
            departmentObjects={departmentObjects}
        />
        <CreateDuplicateQuoteModal
            rental={rental}
            open={createDuplicateQuoteModalOpen}
            setOpen={setCreateDuplicateQuoteModalOpen}
            onQuoteDuplicate={onQuoteDuplicate}
        />
        <div style={{display: "none"}}>
          <div>
            <PrintContract rental={rental} hire={hire_cost} insurance={insurance_cost} ref={printRentalRef}/>
            <PrintMissingFuel rental={rental} ref={printMissingRef}/>
            <PrintDVHTermsConditions ref={printTermsRef}/>
          </div>
        </div>
      </Container>
    )
  } else {
    return <div>Loading...</div>;
  }
}

export default RentalsForm;
